import React from 'react';
import { Link } from 'react-router-dom';

function ContactUs() {
  return (
    <div
      style={{
        fontFamily: "'Georgia','Times New Roman',serif",
        background: "#fff",
        color: "#222",
      }}
    >
      <div
        style={{
          maxWidth: "1100px",
          margin: "0 auto",
          padding: "0 1.5rem 5rem",
        }}
      >
        {/* Back */}
        <Link
          to="/"
          style={{
            fontSize: "13px",
            color: "#c47a1e",
            textDecoration: "none",
            display: "inline-block",
            margin: "1.5rem 0 0",
            userSelect: "none",
          }}
        >
          ← Back to Home
        </Link>

        {/* Heading */}
        <h1
          style={{
            fontFamily: "'Dancing Script','Brush Script MT',cursive",
            fontSize: "3.6rem",
            color: "#ff8b3d",
            margin: "1rem 0 .8rem",
            fontWeight: 700,
          }}
        >
          Let's Get in Touch
        </h1>

        {/* Description */}
        <p
          style={{
            fontSize: "18px",
            lineHeight: "1.8",
            color: "#333",
            marginBottom: "1.3rem",
          }}
        >
          If you have any questions about{" "}
          <em>Christ For India</em>, looking to get involved or asking
          for prayer, <strong>we would love to connect with you!</strong>
        </p>

        {/* Orange Dots */}
        <div
          style={{
            display: "flex",
            gap: "5px",
            marginBottom: "4.5rem",
          }}
        >
          {[...Array(9)].map((_, i) => (
            <div
              key={i}
              style={{
                width: "6px",
                height: "6px",
                borderRadius: "50%",
                background: "#ff8b3d",
              }}
            />
          ))}
        </div>

        {/* Contact Information */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            gap: "2rem",
            flexWrap: "wrap",
            textAlign: "center",
          }}
        >
          {/* Email */}
          <div style={{ flex: 1, minWidth: "220px" }}>
            <a
              href="https://outlook.office.com/mail/deeplink/compose?to=cfimin@christforindia.org"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                textDecoration: "none",
                color: "inherit",
                cursor: "pointer",
                display: "inline-block",
              }}
              title="Click to open Outlook Web compose email"
            >
              <div
                style={{
                  fontSize: "3.8rem",
                  color: "#ff8b3d",
                  marginBottom: "1rem",
                  transition: "transform 0.2s",
                }}
                onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.1)")}
                onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
              >
                📧
              </div>

              <p
                style={{
                  fontSize: "18px",
                  margin: 0,
                  color: "#333",
                  fontWeight: "600",
                }}
              >
                cfimin@christforindia.org
              </p>
            </a>
          </div>

          {/* Address */}
          <div style={{ flex: 1, minWidth: "220px" }}>
            <div
              style={{
                fontSize: "3.8rem",
                color: "#ff8b3d",
                marginBottom: "1rem",
              }}
            >
              ✉️
            </div>

            <p
              style={{
                fontSize: "18px",
                margin: "0 0 .4rem",
              }}
            >
              P.O. Box 271086
            </p>

            <p
              style={{
                fontSize: "18px",
                margin: 0,
              }}
            >
              Dallas, TX 75227
            </p>
          </div>

          {/* Phone */}
          <div style={{ flex: 1, minWidth: "220px" }}>
            <div
              style={{
                fontSize: "3.8rem",
                color: "#ff8b3d",
                marginBottom: "1rem",
              }}
            >
              📞
            </div>

            <p
              style={{
                fontSize: "18px",
                margin: "0 0 .4rem",
              }}
            >
              +1 (800) 943-0380
            </p>

            <p
              style={{
                fontSize: "18px",
                margin: 0,
              }}
            >
              +1 (972) 771-7221
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ContactUs;
